export enum ElementPosition {
    'RIGHT' = 'right',
    'LEFT' = 'left'
}
